import { render } from "./EditContactorView.vue?vue&type=template&id=77a70df4&scoped=true"
import script from "./EditContactorView.vue?vue&type=script&lang=js"
export * from "./EditContactorView.vue?vue&type=script&lang=js"

import "./EditContactorView.vue?vue&type=style&index=0&id=77a70df4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a70df4"]])

export default __exports__